import { z as t } from "zod";
const e = t.object({
  value: t.string(),
  label: t.string(),
  hierarchical: t.boolean(),
  publicly_queryable: t.boolean()
}), s = t.object({
  countries: t.record(t.string(), t.string()),
  currency: t.object({
    slug: t.string(),
    symbol: t.string()
  }),
  product_taxonomies: t.array(e),
  notify_low_stock_amount: t.number(),
  dimension_unit: t.string(),
  weight_unit: t.string(),
  permalinks: t.object({
    product_base: t.string(),
    category_base: t.string(),
    tag_base: t.string(),
    attribute_base: t.string(),
    use_verbose_page_rules: t.boolean(),
    product_rewrite_slug: t.string(),
    category_rewrite_slug: t.string(),
    tag_rewrite_slug: t.string(),
    attribute_rewrite_slug: t.string()
  }),
  product_types: t.array(t.object({
    value: t.string(),
    label: t.string(),
    color: t.string()
  }))
}), o = {
  countries: {},
  currency: {
    slug: "",
    symbol: ""
  },
  product_taxonomies: [],
  notify_low_stock_amount: 0,
  dimension_unit: "",
  weight_unit: "",
  permalinks: {
    product_base: "",
    category_base: "",
    tag_base: "",
    attribute_base: "",
    use_verbose_page_rules: !1,
    product_rewrite_slug: "",
    category_rewrite_slug: "",
    tag_rewrite_slug: "",
    attribute_rewrite_slug: ""
  },
  product_types: []
};
export {
  o as DEFAULT_WOOCOMMERCE,
  e as TaxonomySchema,
  s as WoocommerceSchema
};
